<template>
  <transition name="login">
    <div class="login">
      <div class="pane left">
        <div class="form-login">
          <div v-if="displaySSO" id="btnSSO" class="sso btnLogin">
            <!-- <button type="submit" class="button" onclick="window.location.href='https://dev-cdc.terasp.net/StartSSO.aspx'" style="margin-left:10px;">
									<span>Connexion SSO POC</span>
            </button>-->
            <button
              type="submit"
              class="button"
              @click="sso_connect()"
              style="margin-left:10px;"
            >
              <span>Connexion</span>
              <br />
              <img src="../assets/img/logo.png" alt="CDC Habitat" style="width: 100px;" />
            </button>
            <span>OU</span>
            <br />
          </div>

          <div id="btnAdequation" class="adequation btnLogin">
            <!-- <button type="submit" class="button" onclick="window.location.href='https://dev-cdc.terasp.net/StartSSO.aspx'" style="margin-left:10px;">
									<span>Connexion SSO POC</span>
            </button>-->
            <button type="submit" class="button" @click.stop="toggleForm"  style="margin-left:10px;">
              <span>Connexion</span>
              <br />
              <img
                src="../assets/img/logo_adequation_libelle.png"
                alt="Adequation"
                style="width: 100px;"
              />
            </button>
          </div>

          <!-- Formulaire d'authentification ADEQUATION : à afficher que si l'utilisateur clique sur "connexion Adequation" -->
          <form id="formAdequation" class="form" v-click-outside="() => displayForm = false" @submit.prevent="submit_login()" v-if="displayForm">
            <div class="line">
              <p class="intro">
                Saisissez vos identifiants pour vous connecter avec votre compte
                <b>ADEQUATION</b>.
              </p>
            </div>
            <div class="line">
              <label class="label" for="login">E-mail</label>
              <input
                type="login"
                v-model="email"
                class="input"
                id="login"
                ref="autofocus"
                placeholder="exemple@adequation-france.com"
                @keydown="reset_error_message"
                required
                @click.stop
              />
            </div>
            <div class="line">
              <label class="label" for="password">Mot de passe</label>
              <input
                type="password"
                v-model="password"
                class="input"
                id="password"
                placeholder="Votre mot de passe"
                @keydown="reset_error_message"
                required
                @click.stop
              />
            </div>
            <div class="line">
              <div class="stay-connected" @click.stop="stay_connected = !stay_connected">
                <div class="checkbox" :class="{ checked: stay_connected }">
                  <icon file="check" :size="16" />
                </div>
                <span class="text">Rester connecté</span>
              </div>
            </div>
            <div class="buttons">
              <button type="submit" class="button" @click.stop>
                <span>Connexion</span>
                <div class="loader">
                  <icon file="loader" :size="32" />
                </div>
              </button>
            </div>
            <br />
            <div class="line">
              <p>{{ connexion_error }}</p>
            </div>
            <!-- <div class="line">
							<div class="forgot">
								<a>Mot de passe oublié ?</a>
								<span class="dot">•</span>
								<a>À propos</a>
							</div>
            </div>-->
          </form>
          <br />
          <br />
        <div class="logout-message">{{logout_message}}</div>
        </div>
      </div>
      <div class="pane right">
        <div class="illustration">
          <span v-html="require('../assets/img/resume.svg')"></span>
        </div>
        <div class="headline">
          <img src="../assets/img/logo.png" alt="CDC Habitat" />
          <p class="slogan">
            Une nouvelle façon de retrouver
            <br />vos études ADEQUATION
          </p>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "login",
  data: function() {
    return {
      email: "",
      password: "",
      stay_connected: true,
      displayForm: false
    };
  },
  computed: {
    ...mapGetters(["is_authenticated", "connexion_error","logout_message"]),
    displaySSO(){
      // display SSO button only in production
      //return process.env.VUE_APP_ES_ENV == "PROD"
      return true;
    }
  },
  methods: {
    sso_connect() {
      this.$gtm.trackEvent({
        category: 'Compte utilisateur',
        action: 'Login',
        label: 'SSO'
      });
      
      window.location.href=process.env.VUE_APP_API_GETSSOURL;
    },
    submit_login: function() {
      this.$store.dispatch("set_token_loading_on")

      this.$gtm.trackEvent({
        category: 'Compte utilisateur',
        action: 'Login',
        label: 'Adequation'
      });

      this.$store.dispatch("auth_request", {
        email: this.email,
        password: this.password
      });
    },
    reset_error_message() {
      this.$store.dispatch("reset_connexion_error");
    },
    toggleForm() {
      this.displayForm = !this.displayForm;

      if(this.displayForm) {
        setTimeout(() => {
            console.log(this.$refs.autofocus)
            this.$refs.autofocus.focus();
        })
      }
    }
  }
};
</script>

<style lang="stylus" scoped>
@import '../assets/css/app';
@import '../assets/css/grid';

.logout-message
  width: 432px

.login {
  position: fixed;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  height: 100%;
  width: 100%;
  background: #fff;
  transition: 0.25s easeOutQuart;

  &.login-leave-to {
    opacity: 0;
  }

  .pane {
    float: left;
    height: 100%;

    &.left {
      width: 30%;
      background-color: red;
    }

    &.right {
      width: 70%;

      .headline {
        padding: 32px 0 0 0;
        text-align: center;
        color: #333;

        img {
          width: 300px;
          margin: 0 0 24px 0;
        }

        .slogan {
          height: 64px;
          text-align: center;
          font-size: 2.4rem;
          line-height: 32px;
          white-space: nowrap;
        }
      }

      .illustration {
        position: absolute;
        left: 50%;
        top: 55%;
        width: 50%;
        transform: translate(-50%, -50%);

        > span {
          display: block;

          > svg {
            display: block !important;
            width: 100% !important;
            height: auto !important;
          }
        }
      }
    }
  }
}

.form-login {
  width: 300 px;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  color: #fff;
  font-size: 1.5rem;

  .sso{
    .button{
      height: 96px;
    }
  }
  .adequation{
    .button{
      height: 64px;
      opacity:0.7
    }
  }


  .sso, .adequation {
    text-align: center;

    .button {
      border: none;
      // height: 68px;
      min-width: 280px;
      padding: 0 24px;
      border-radius: 8px;
      color: #333;
      border: none;
      cursor: pointer;
      outline: none;
      font: inherit;
      font-weight: 500;
      // color: #fff;
      outline: none;
      margin: 10px;
      background-color : white;

      &:hover {
        opacity: 0.7;
      }

      &:active {
        background-color: darken(#333, 20%);
        transform: translateY(1px);
      }

      .loader {
        display: none;
        position: absolute;
        left: 50%;
        top: 50%;
        width: 32px;
        height: 32px;
        margin: -16px 0 0 -16px;
        animation: rotate 1s infinite linear;
        transform-origin: center center;
      }
    }
  }

  .visible{
    display : block;
  }
  .hidden{
    display : none;
  }
  .form {
    width: 320px;
    padding: 16px;
    opacity: 0.8;
    // border-radius: 15px;
    // border-color: #9e0909;
    box-shadow: 1px 3px 3px 2px #9e0909;

    .intro {
      margin: 0 0 56px 0;
      font-size: 1.7rem;
      line-height: 22px;
    }

    .line {
      margin: 0 0 16px 0;

      .label {
        display: block;
        margin: 0 0 4px 0;
        color: #fff;
        font-weight: 500;
      }

      .input {
        display: block;
        width: 100%;
        height: 48px;
        padding: 0 16px;
        background: #fff;
        border: none;
        border-radius: radius;
        // border-radius 48px
        font: inherit;
        font-size: 1.5rem;
        color: #333;
        outline: none;

        &:focus {
          border-color: red;
        }
      }

      textarea.input {
        height: auto;
        padding: 16px;
        line-height: 16px;
      }
    }

    .buttons {
      text-align: right;

      .button {
        border: none;
        height: 48px;
        min-width: 64px;
        padding: 0 24px;
        border-radius: 48px;
        background: #333;
        border: none;
        cursor: pointer;
        outline: none;
        font: inherit;
        font-weight: 500;
        color: #fff;
        outline: none;

        &:hover {
          background-color: darken(#333, 10%);
        }

        &:active {
          background-color: darken(#333, 20%);
          transform: translateY(1px);
        }

        .loader {
          display: none;
          position: absolute;
          left: 50%;
          top: 50%;
          width: 32px;
          height: 32px;
          margin: -16px 0 0 -16px;
          animation: rotate 1s infinite linear;
          transform-origin: center center;
        }
      }
    }

    .stay-connected {
      margin: 16px 0 0 0;
      font-size: 1.3rem;
      text-align: left;
      line-height: 16px;
      color: #fff;
      cursor: pointer;

      .checkbox {
        float: left;
        width: 16px;
        height: 16px;
        background: #fff;
        border-radius: (radius / 2px);

        &.checked {
          > .icon {
            opacity: 1;
          }
        }

        > .icon {
          display: block;
          color: red;
          opacity: 0;
          top: 1px;
        }
      }

      .text {
        display: block;
        margin-left: 22px;
      }
    }

    .forgot {
      margin: 80px 0 0 0;
      text-align: center;

      a {
        cursor: pointer;
        text-decoration: underline;

        &:hover {
          text-decoration: none;
        }
      }

      .dot {
        margin: 0 8px;
      }
    }
  }
}
</style>
